import gql from "graphql-tag";

const query = gql`
  query GraphicSet($graphicSetId: ID, $customerId: ID) {
    graphicset(graphicSetId: $graphicSetId, customerId: $customerId) {
      id
      name
      description
      customerId
      hasEvents
      layouts {
        order
        sendTo
        seconds
        assetId
        assetIdCodename
        assetIdCategoryIds
        pos {
          x
          y
        }
        size {
          x
          y
        }
        segments {
          type
          start
          end
        }
      }
      schedules {
        type
        period
      }
    }
  }
`;

export default (graphicSetId, customerId) => ({
  query,
  skip: !graphicSetId || !customerId,
  variables: { graphicSetId, customerId },
});
